
import React, { useEffect, useState } from 'react'
import { Box, Button, Card, CardActions, CardMedia, Grid, Typography } from '@mui/material'
import { ApiGetAllImages } from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
import { uploadImageBuffer } from '../../../apiService/Core/ApiEndPoint.tsx'
import axios from 'axios'

function ViewAllIMages() {

    const [images, setImageList] = useState<any>([])
    const [downloading, setDownloading] = useState<any>({});
    const reportHeaderId = localStorage.getItem('reportHeaderId')


    const getAllImages = async () => {
        try {
            const data = `?reportHeaderId=${reportHeaderId}`
            const res = await ApiGetAllImages(data)
            if (res.status) {
                setImageList(res.images)
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    }
    useEffect(() => {
        getAllImages()
    }, [reportHeaderId])



    // function parseS3Url(url: string) {
    //     const parsed = new URL(url);
    //     const parts = parsed.pathname.split("/").filter(Boolean);
    //     const bucket = parts[0];
    //     let key = parts.slice(1).join("/");
    //     key = key.replace(/\u202f/g, " ");
    //     return { bucket, key };
    // }
    // const downloadImage = async (imageSrc:string) => {
    //     try {
    //         const presignedUrl = imageSrc;
    //         const { bucket, key } = parseS3Url(presignedUrl);

    //         const safeKey = encodeURIComponent(key);
    //         const safeBucket = encodeURIComponent(bucket);

    //         const res = await axios.get(
    //             `${uploadImageBuffer}?bucket=${safeBucket}&key=${safeKey}`,
    //             { responseType: "blob" }
    //         );

    //         // Create blob URL
    //         const blobUrl = URL.createObjectURL(res.data);
    //         console.log("Blob URL----->", blobUrl)
    //         // Trigger download
    //         const link = document.createElement("a");
    //         link.href = blobUrl;
    //         link.download = "image.jpg"; // fallback name
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);

    //         // Revoke blob URL after a short delay
    //         setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

    //     } catch (err) {
    //         console.log("Failed to fetch image:", err);
    //     } 
    // };
   const downloadImage = async (imageUrl: string, fileName = "image.jpg") => {
  try {
    const response = await fetch(imageUrl, { mode: "cors" });
    const blob = await response.blob();

    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading image:", error);
  }
};
    return (
        <Box className='h-100 w-100 container-fluid p-3'>
            <Box className='mt-2'>
                {images?.TaskPhotos?.length > 0 && (
                    <Box className='TaskPhotos mb-3'>
                        <Typography className='fw-bold mb-3' variant='h5'>Task Photos</Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "20px"
                            }}
                        >
                            {images?.TaskPhotos.map((imageUrl: string, index: number) => {
                                return (
                                    <Grid key={index} boxShadow={'0px 0px 10px black'} borderRadius={'10px'} className='p-1   gap-2 d-flex align-items-center flex-column'>
                                        <Box flex={1}>
                                            <Box component={'img'} width={'100%'} borderRadius={'10px'} src={imageUrl}></Box>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Box>
                    </Box>
                )}
                {images?.InvoicePhotos?.length > 0 && (
                    <Box className='TaskPhotos mb-3'>
                        <Typography className='fw-bold mb-3' variant='h4'>Invoice Images</Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "20px"
                            }}
                        >
                            {images?.InvoicePhotos.map((imageUrl: string, index: number) => {
                                return (
                                    <Grid key={index} boxShadow={'0px 0px 10px black'} borderRadius={'10px'} className='p-1 gap-2 d-flex align-items-center flex-column'>
                                        <Box flex={1}>
                                            <Box component={'img'} width={'100%'} borderRadius={'10px'} src={imageUrl}></Box>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Box>
                    </Box>
                )}
                {images?.LocationPhotos?.length > 0 && (
                    <Box className='TaskPhotos mb-3'>
                        <Typography className='fw-bold mb-3' variant='h4'>Location Photos</Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "20px"
                            }}
                        >
                            {images?.LocationPhotos.map((imageUrl: string, index: number) => {
                                return (
                                    <Grid key={index} boxShadow={'0px 0px 10px black'} borderRadius={'10px'} className='p-1 gap-2 d-flex align-items-center flex-column'>
                                        <Box flex={1}>
                                            <Box component={'img'} width={'100%'} borderRadius={'10px'} src={imageUrl}></Box>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Box>
                    </Box>
                )}
                {images?.ShopperBagImages?.length > 0 && (
                    <Box className='TaskPhotos mb-3'>
                        <Typography className='fw-bold mb-3' variant='h4'>ShopperBag Photos</Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "20px"
                            }}
                        >
                            {images?.ShopperBagImages.map((imageUrl: string, index: number) => {
                                return (
                                    <Grid key={index} boxShadow={'0px 0px 10px black'} borderRadius={'10px'} className='p-1   gap-2 d-flex align-items-center flex-column'>
                                        <Box flex={1}>
                                            <Box component={'img'} width={'100%'} borderRadius={'10px'} src={imageUrl}></Box>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Box>
                    </Box>
                )}
                {images?.QuestionAnswer?.length > 0 && (
                    <Box className='TaskPhotos'>
                        <Typography className='fw-bold mb-3' variant='h4'>QuestionAnswer Photos</Typography>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "20px"
                            }}
                        >
                            {images?.QuestionAnswer.map((imageUrl: string, index: number) => {
                                return (
                                    <Grid key={index} boxShadow={'0px 0px 10px black'} borderRadius={'10px'} className='p-1 gap-2 d-flex align-items-center flex-column'>
                                        <Box flex={1}>
                                            <Box component={'img'} width={'100%'} borderRadius={'10px'} src={imageUrl}></Box>
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Box>
                    </Box>
                )}

            </Box>
        </Box>
    )
}

export default ViewAllIMages
